import React from 'react';
import Divider from "@mui/material/Divider";
import styles from './mydivider.module.css';

const MyDivider = (props) => {
    return (
        <Divider className={styles.divider} {...props} />
    );
};

export default MyDivider;